export default function testFnc() {
  console.log("Start components");
}
